import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ErrorLogOccurrenceModel, ErrorLogStatus } from '../../../../business-entities/error-log-analysis-report.model';
import { formatJson, getStatusOption, toLocalDate } from '../error-log-analysis.helper';

/**
 * Occurrences of one endpoint (time, request and error), newest first. Used by the quick view and the endpoint details page.
 */
@Component({
  selector: 'app-error-log-occurrence-list',
  templateUrl: './error-log-occurrence-list.component.html',
  styleUrls: ['../error-log-shared.css', './error-log-occurrence-list.component.css']
})
export class ErrorLogOccurrenceListComponent {

  @Input() items: ErrorLogOccurrenceModel[] = [];
  @Input() totalCount: number = 0;
  @Input() loading: boolean = false;
  @Output() loadMore = new EventEmitter<void>();

  openId: number = null;

  readonly toLocalDate = toLocalDate;
  readonly formatJson = formatJson;

  getStatus(status: ErrorLogStatus) {
    return getStatusOption(status);
  }

  toggle(id: number) {
    this.openId = this.openId === id ? null : id;
  }

  trackById(index: number, item: ErrorLogOccurrenceModel): number {
    return item.id;
  }
}
